// ProjectSlice.js
import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    list: [],
    selectedUser: null,
    isModalVisible: false,
  },
  reducers: {
    setUserList(state, action) {
      state.list = action.payload;
    },
    setSelectedUser(state, action) {
      if (!action.payload.id) {
        state.selectedUser = {
          address: '',
          city: '',
          dob: '',
          email: '',
          firstName: '',
          fullName: '',
          lastName: '',
          mobile: '',
          password: '',
          phone: '',
          position: '',
          state: '',
          zip: ''

        }
      }
      else {
        state.selectedUser = action.payload;
      }
    },
    setModalVisibility(state, action) {
      state.isModalVisible = action.payload;
    },
    clearSelectedUser(state) {
      state.selectedUser = null;
    },
  },
});

export const { setUserList, setSelectedUser, setModalVisibility, clearSelectedUser } = userSlice.actions;
export default userSlice.reducer;
